import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import esTranslation from './locales/es/translation.json';
import enTranslation from './locales/en/translation.json';
import ptTranslation from './locales/pt/translation.json';

const resources = {
  en: { translation: enTranslation },
  es: { translation: esTranslation },
  pt: { translation: ptTranslation }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    // Mercado objetivo 100% hispanohablante (Ecuador/LatAm) — detectar el
    // idioma del navegador/SO puede mostrar inglés a un visitante real que sí
    // habla español (equipos de trabajo en inglés, perfiles corporativos,
    // etc.), justo al público menos técnico que tenemos. Por eso no se usa
    // 'navigator' en el orden de detección: el español es el default fijo
    // para cualquier visita nueva, y solo cambia si la persona lo elige a
    // mano con el selector EN/PT (esa elección sí se recuerda vía localStorage).
    detection: {
      order: ['querystring', 'localStorage'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
